import React from 'react'
import { TouchableWithoutFeedback } from 'react-native'
import variables from '../assets/stylesheets/variables'
import Text from './Text'
import { useNavigation } from '@react-navigation/native'

const Link = ({ children, screen, params = {}}) => {
  const navigation = useNavigation()

  const onPress = () => {
    navigation.navigate(screen, { ...params })
  }

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <Text style={{ color: variables.primaryColor, fontFamily: variables.fontFamily.semiBold }}>
        {children}
      </Text>
    </TouchableWithoutFeedback>
  )
}

export default Link
